module.exports = __webpack_public_path__ + "static/media/Erbaum-Regular.83806ffa.woff";